import { Outlet, useLocation } from 'react-router-dom';
import { LoginAppearanceFrame } from './appearance/LoginAppearanceFrame';
import { useLoginAppearance } from './appearance/useLoginAppearance';

const AuthLayout = () => {
  const { appearance, loading } = useLoginAppearance();
  const { pathname } = useLocation();
  const isLoginPage = pathname.endsWith('/login');

  if (loading) return <output className="d-flex flex-center min-vh-100">Carregando...</output>;

  return (
    <LoginAppearanceFrame appearance={appearance} showHeading={isLoginPage}>
      <Outlet />
    </LoginAppearanceFrame>
  );
};

export { AuthLayout };
